module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion', {
    staticClass: "mailbox",
    class: {
      injected: _vm.injected
    }
  }, [(_vm.status == _vm.STATUS.ERROR) ? _c('div', {
    staticClass: "pcenter"
  }, [_c('i', {
    staticClass: "fa fa-remove grey bigIcon"
  }), _c('h2', [_c('small', [_vm._v(_vm._s(_vm.$t("globals.error")))])])]) : _vm._e(), (_vm.status == _vm.STATUS.LOADING) ? _c('div', {
    staticClass: "padding",
    staticStyle: {
      "color": "white"
    },
    on: {
      "fire": _vm.doNothing
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v("  \n" + _vm._s(_vm.$t("conversations.loadingOne")))]) : _vm._e(), (_vm.status == _vm.STATUS.LOADED) ? [_c('conversation', {
    attrs: {
      "conversation": _vm.conversation,
      "initial-active": _vm.active,
      "initial-stay-active": _vm.stayActive,
      "injected": _vm.injected
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42465f22","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Conversations/ConversationOnSharedObject.vue
// module id = 879
// module chunks = 13